/**
 * Application Constants
 * Configuration values used across the application
 */

// ============================================================================
// EMERGENCY FALLBACK VALUES - DO NOT EDIT DIRECTLY
// ============================================================================
// The following config values are EMERGENCY FALLBACKS ONLY, used when the
// database is unavailable. The database (ConfigSettings collection) is the
// source of truth. Edit these via Admin Dashboard → Configuration Settings.
// ============================================================================

// User role options - FALLBACK ONLY (use useConfig() hook in components)
export const ROLE_OPTIONS = [
  { value: 'user', label: 'User' },
  { value: 'student', label: 'Student' },
  { value: 'admin', label: 'Admin' }
];

// Landing page options - FALLBACK ONLY (use useConfig() hook in components)
export const LANDING_PAGE_OPTIONS = [
  { value: '/', label: 'Home Page' },
  { value: '/teaching', label: 'Teaching/Course Page' },
  { value: '/admin', label: 'Admin Dashboard' }
];

// Available courses - EMERGENCY FALLBACK ONLY
// DO NOT USE DIRECTLY - Fetch from /api/content-items/courses/dropdown
// This fallback only exists for offline/network failure scenarios
// ALWAYS use the API in production
export const AVAILABLE_COURSES = [
  { id: 'rp001', name: 'RP001 - GitHub Copilot Tutorial' },
  { id: 'itws1100', name: 'ITWS 1100 - Intro to IT & Web Science' },
  { id: 'itws4500', name: 'ITWS 4500 - Web Systems Development' }
];

// ============================================================================
// ACTUAL APPLICATION CONSTANTS (OK to edit directly)
// ============================================================================

// User settings tabs configuration
export const USER_SETTINGS_TABS = [
  { id: 'profile', label: 'Profile', icon: '👤' },
  { id: 'security', label: 'Security', icon: '🔒' },
  { id: 'password', label: 'Password', icon: '🔑' },
  { id: 'account', label: 'Account', icon: '⚙️' }
];

// Default values
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 100;

// Animation durations (in seconds)
export const ANIMATION_DURATION = {
  fast: 0.2,
  normal: 0.3,
  slow: 0.6
};

// Toast notification duration (in milliseconds)
export const TOAST_DURATION = 3000;
